/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppConfigSettings } from 'app/core/models/app-config';
import { TranslateModule } from '@ngx-translate/core';
import { importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

const CONFIG_FILE_NAME = '/assets/config.json';

fetch(CONFIG_FILE_NAME)
    .then(response => response.json() as Promise<AppConfigSettings>)
    .then(configSettings => {
        const configData = appConfig(configSettings);
        bootstrapApplication(AppComponent, {
            ...configData,
            providers: [
                ...(configData.providers || []),
                importProvidersFrom(
					TranslateModule.forRoot({
							loader: provideTranslateHttpLoader({
							prefix: './assets/i18n/',
							suffix: '.json'
						})
					})
                )
            ]
        }).catch(err => {
            console.error('Bootstrap failed:', err);
            throw err;
        });
    })
    .catch(err => console.error(`Error loading "${CONFIG_FILE_NAME}" before bootstrap.`, err));